// extracted by mini-css-extract-plugin
export default {"site-layout":"Sidenav_site-layout__fveBQ","site-layout-background":"Sidenav_site-layout-background__zfY8-","menuLabel":"Sidenav_menuLabel__M68ez"};